"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const video = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-video` : '') + (description ? ` desc-video` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-video"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-video"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.59 3.25A2.25 2.25 0 0 1 4.9 1.27l16.32 8.75a2.25 2.25 0 0 1 0 3.96L4.9 22.73a2.25 2.25 0 0 1-3.31-1.98V3.25Zm1.5 17.5a.75.75 0 0 0 1.1.66l16.33-8.75.08-.05a.75.75 0 0 0 0-1.22l-.08-.05L4.19 2.59a.75.75 0 0 0-1.1.66v17.5Z",
    fill: "black"
  }));
};
var _default = exports.default = video;